import styled from "@emotion/styled";
import { RouteID } from "../../routing/routes";
import { baseStrokeColor } from "./NavItemLink";
import NavItem from "./NavItemLink";
import { NavContainer as NavContainerBase } from "./RankingsOuterGrid";
import { trackEngagementEvent } from "../../sharedUtilities/analytics";
import { spacing, breakpoints } from "@atlas-int/tokens";
import lexicon from "./lexicon";

const axisMargin = { left: 190, right: 90 };

const NavContainer = styled(NavContainerBase)`
  display: flex;
  margin-top: ${spacing[16]};
  margin-bottom: ${spacing[16]};
  margin-right: ${axisMargin.right}px;

  @media (max-width: ${breakpoints.md}) {
    margin-left: 0;
    margin-right: 0;
  }
`;
const NavList = styled.ul`
  flex: 1;
  display: flex;
  gap: ${spacing[20]};
  border-bottom: 1px solid ${baseStrokeColor};
  justify-content: space-between;
  align-items: flex-end;
  list-style: none;
  padding: 0;
  margin: 0;
`;

interface Props {
  productClass?: string;
}

export default ({ productClass }: Props) => {
  const queryParams = productClass ? { productClass } : {};
  const navLinkGroup = {
    country: { id: RouteID.CountryRankings, queryParams },
    product: { id: RouteID.ProductRankings, queryParams },
    growth: { id: RouteID.GrowthProjections, queryParams },
  };

  return (
    <NavContainer>
      <NavList>
        <li
          onClick={() =>
            trackEngagementEvent(
              "click",
              "countryRankings",
              "button",
              "rankings",
            )
          }
        >
          <NavItem groupKey="country" group={navLinkGroup}>
            {lexicon.menu.country.heading}
          </NavItem>
        </li>
        <li
          onClick={() =>
            trackEngagementEvent(
              "click",
              "productRankings",
              "button",
              "rankings",
            )
          }
        >
          <NavItem groupKey="product" group={navLinkGroup}>
            {lexicon.menu.product.heading}
          </NavItem>
        </li>
        <li
          onClick={() =>
            trackEngagementEvent(
              "click",
              "growthProjections",
              "button",
              "rankings",
            )
          }
        >
          <NavItem groupKey="growth" group={navLinkGroup}>
            {lexicon.menu.projections.heading}
          </NavItem>
        </li>
      </NavList>
    </NavContainer>
  );
};
